import { Injectable } from '@angular/core';
import {
  DimensionType,
  MaterialType,
  NbColorsType,
  PrintMethodType,
  PrintProductTypes,
  StickerSubTypes,
} from '../../../../../model/print-production/print-product-enums';

@Injectable({
  providedIn: 'root',
})
export class PrintProductionProductOptionsService {
  constructor() {}

  MaterialOptions: Record<string, MaterialType[]> = {
    [PrintProductTypes.STICKER]: [],
    [PrintProductTypes.IMMO_IP_SIGN]: [
      MaterialType.DUOPROP_4MM,
      MaterialType.X_PRINT_8MM,
      MaterialType.DIBOND_3MM,
      MaterialType.OTHER,
    ],
    [PrintProductTypes.ADHESIVE_SIGN]: [
      MaterialType.DUOPROP_4MM,
      MaterialType.OTHER,
    ],
    [PrintProductTypes.ARROW]: [MaterialType.DUOPROP_4MM, MaterialType.OTHER],
    [PrintProductTypes.VARIA]: [MaterialType.DUOPROP_4MM, MaterialType.OTHER],
  };

  StickerMaterialOptions: Record<string, MaterialType[]> = {
    [StickerSubTypes.IMMO_WINDOW_STICKER]: [
      MaterialType.VINYL_REMOVABLE,
      MaterialType.VINYL_PERMANENT,
      MaterialType.VINYL_ONE_WAY,
      MaterialType.OTHER,
    ],
    [StickerSubTypes.IMMO_STANDARD_STICKER]: [
      MaterialType.VINYL_REMOVABLE,
      MaterialType.VINYL_PERMANENT,
      MaterialType.VINYL_OPAQUE,
      MaterialType.OTHER,
    ],
    [StickerSubTypes.CUSTOM_STICKER]: [
      MaterialType.VINYL_REMOVABLE,
      MaterialType.VINYL_PERMANENT,
      MaterialType.VINYL_ONE_WAY,
      MaterialType.VINYL_OPAQUE,
      MaterialType.OTHER,
    ],
  };

  DimensionOptions: Record<string, DimensionType[]> = {
    [PrintProductTypes.STICKER]: [],
    [PrintProductTypes.IMMO_IP_SIGN]: [
      DimensionType.W100_H140,
      DimensionType.W70_H100,
      DimensionType.CUSTOM,
    ],
    [PrintProductTypes.ADHESIVE_SIGN]: [
      DimensionType.W100_H140,
      DimensionType.W70_H100,
      DimensionType.W50_H140,
      DimensionType.W70_H180,
      DimensionType.CUSTOM,
    ],
    [PrintProductTypes.ARROW]: [DimensionType.W23_H50, DimensionType.CUSTOM],
    [PrintProductTypes.VARIA]: [DimensionType.CUSTOM],
  };

  StickerDimensionOptions: Record<string, DimensionType[]> = {
    [StickerSubTypes.IMMO_WINDOW_STICKER]: [
      DimensionType.W100_H140,
      DimensionType.W70_H100,
      DimensionType.W50_H70,
      DimensionType.W35_H50,
      DimensionType.W25_H35,
      DimensionType.CUSTOM,
    ],
    [StickerSubTypes.IMMO_STANDARD_STICKER]: [
      DimensionType.W98_H14,
      DimensionType.W60_H12,
      DimensionType.W45_H10,
      DimensionType.CUSTOM,
    ],
    [StickerSubTypes.CUSTOM_STICKER]: [DimensionType.CUSTOM],
  };

  PrintMethodColorOptions: Record<string, NbColorsType[]> = {
    [PrintMethodType.DIGITAL]: [
      NbColorsType.ONE,
      NbColorsType.TWO,
      NbColorsType.THREE,
      NbColorsType.FOUR,
      NbColorsType.CMYK,
    ],
    [PrintMethodType.SCREENPRINT]: [
      NbColorsType.ONE,
      NbColorsType.TWO,
      NbColorsType.THREE,
      NbColorsType.FOUR,
      NbColorsType.CMYK,
    ],
    [PrintMethodType.SCREENPRINT_DIGITAL]: [
      NbColorsType.ONE,
      NbColorsType.TWO,
      NbColorsType.THREE,
      NbColorsType.FOUR,
    ],
  };

  TypePrintMethodOptions: Record<string, PrintMethodType[]> = {
    [PrintProductTypes.IMMO_IP_SIGN]: [
      PrintMethodType.DIGITAL,
      PrintMethodType.SCREENPRINT,
      PrintMethodType.SCREENPRINT_DIGITAL,
    ],
    [PrintProductTypes.ADHESIVE_SIGN]: [
      PrintMethodType.DIGITAL,
      PrintMethodType.SCREENPRINT,
    ],
    [PrintProductTypes.STICKER]: [
      PrintMethodType.DIGITAL,
      PrintMethodType.SCREENPRINT,
    ],
    [PrintProductTypes.ARROW]: [
      PrintMethodType.DIGITAL,
      PrintMethodType.SCREENPRINT,
    ],
    [PrintProductTypes.VARIA]: [
      PrintMethodType.DIGITAL,
      PrintMethodType.SCREENPRINT,
    ],
  };

  getEnumKeyAsString(value: string): string | undefined {
    return Object.keys(PrintProductTypes).find(
      (key) =>
        PrintProductTypes[key as keyof typeof PrintProductTypes] === value
    );
  }

  public getAvailableMaterials(
    productType: string,
    subtype?: string
  ): MaterialType[] {
    if (
      productType === this.getEnumKeyAsString(PrintProductTypes.STICKER) &&
      subtype
    ) {
      return this.StickerMaterialOptions[StickerSubTypes[subtype]] || [];
    }
    return this.MaterialOptions[PrintProductTypes[productType]] || [];
  }

  public getAvailableDimensions(
    productType: string,
    subtype?: string
  ): DimensionType[] {
    if (
      productType === this.getEnumKeyAsString(PrintProductTypes.STICKER) &&
      subtype
    ) {
      return this.StickerDimensionOptions[StickerSubTypes[subtype]] || [];
    }
    return this.DimensionOptions[PrintProductTypes[productType]] || [];
  }

  public getAvailableColors(printMethodType: string): NbColorsType[] {
    return this.PrintMethodColorOptions[PrintMethodType[printMethodType]] || [];
  }

  public getAvailablePrintMethods(productType: string): PrintMethodType[] {
    return this.TypePrintMethodOptions[PrintProductTypes[productType]] || [];
  }
}
